import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: '',
  data: {}
};

export const updateScorecardNameSlice = createSlice({
  name: "updateScorecardName",
  initialState,
  reducers: {
    updateScorecardNameStart: (state) => ({
      ...state,
      loading: true,
      error: false,
      success: false,
      message: ''
    }),
    updateScorecardNameSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      success: true,
      data: action.payload || {},
    }),
    updateScorecardNameFailure: (state, action) => ({
      ...state,
      loading: false,
      error: true,
      message: action?.payload?.message || ''
    }),
    resetScorecardName: () => ({
      ...initialState,
    })
  },
});

export const {
  updateScorecardNameStart,
  updateScorecardNameSuccess,
  updateScorecardNameFailure,
  resetScorecardName,
} = updateScorecardNameSlice.actions;

export const createOrRenameScorecardName = (payload, scorecardId) => (dispatch) => {
  dispatch(updateScorecardNameStart());

  const apiCall = scorecardId ? 
    apiService.put(`${Constants.API.SCORE_CARD}/${scorecardId}`, payload) 
    : apiService.post(Constants.API.SCORE_CARD, payload);

  apiCall.then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        if (scorecardId) {
          dispatch(updateScorecardNameSuccess());
        } else {
          dispatch(updateScorecardNameSuccess(data?.data));
        }
      } else {
        dispatch(updateScorecardNameFailure());
      }
    } else {
      dispatch(updateScorecardNameFailure());
    }
  }).catch((error) => {
    if (error?.response?.status === 400) {
      dispatch(updateScorecardNameFailure({
        message : error?.response?.data?.systemMessage?.message
      }));
    } else {
      dispatch(updateScorecardNameFailure());
    }
  })

};

export default updateScorecardNameSlice.reducer;
